// Offline sales in Delta POS for Windows (2 November 2026; docs/offline-pos.md): the register's preparation card, the
// offline register and the administrator's registers page. Arabic needs review by an Arabic copy editor.
export const OFFLINE_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    // Preparation card on POS Home (desktop app only)
    offCardTitle: "Offline sales on this register",
    offCardIntro: "If Delta cannot be reached, this register keeps selling for cash from what it was prepared with. Every sale is saved on this PC first and sent to Delta when it answers again.",
    offCardOld: "This Delta POS app has no offline sales. Install the latest Delta POS for Windows from Printers on this PC.",
    offCardUnavailable: "Offline sales could not start on this PC: {x}",
    offActivateHint: "First make this PC a Delta register: an administrator creates it in Registers and gives you its one-time activation code.",
    offActivateCode: "Activation code",
    offActivate: "Activate this PC",
    offActivated: "This PC is register {code} · {name}.",
    offPrepare: "Prepare for offline",
    offPrepareAgain: "Prepare again",
    offPrepareNeedsShift: "Open a shift first: offline sales go into the cash drawer of your open shift.",
    offPrepared: "Prepared for shift {n} until {t} · up to {m} sales · {i} items.",
    offNotPrepared: "Not prepared for offline sales.",
    offPrepareDone: "This register is prepared for offline sales.",
    offAssetsMissing: "The register's files were not all downloaded ({x}); it cannot open offline until preparing succeeds.",
    offOpen: "Open the offline register",
    offSyncNow: "Send now",
    offPending: "Waiting to send",
    offHeld: "Held for review",
    offFailed: "Refused",
    offSynced: "Sent",
    offLastError: "Last attempt",
    offErr_unreachable: "Delta did not answer",
    offOldest: "Oldest waiting since {t}",
    offRules: "Offline: cash into this shift's drawer only, walk-in customers, list prices, no discounts, no refunds, no drafts. Items below cost, without cost or price, or out of stock are not sold.",
    // Offline register
    offTitle: "Offline register",
    offBanner: "Delta cannot be reached. Sales are saved on this PC and sent to Delta when it answers again.",
    offOnline: "Delta answers again",
    offOffline: "Offline",
    offBack: "Back to Delta",
    offCheck: "Check connection",
    offSales: "Offline sales",
    offSell: "Sale",
    offShift: "Shift {n} · {c}",
    offDevice: "Register {code}",
    offGrantUntil: "Offline selling until {t} · {u} of {m} sales",
    offComplete: "Complete cash sale",
    offSaved: "Sale {r} saved on this PC.",
    offReceipt: "Receipt",
    offPrintCopy: "Print a copy",
    offRetryPrint: "Print again (same receipt)",
    offNewSale: "New sale",
    offPrinting: "Printing…",
    offPrinted: "Printed on {p}.",
    offPrintFailed: "Not printed: {x}. Nothing was charged twice; the sale is saved.",
    offPrintUnknown: "Not known whether it printed ({x}). Look at the printer: if nothing came out, print a copy.",
    offPrintNone: "No receipt printer is set up on this PC (Printers on this PC).",
    offReceiptBanner: "OFFLINE SALE · saved on this register, not yet in Delta",
    offReceiptNo: "Register receipt",
    offConfirmTotal: "The minimum tobacco fee raises the total to {x}. Take this total?",
    offConfirm: "Take {x}",
    offNoSales: "No offline sales on this register.",
    offInvoice: "Delta invoice",
    offState_pending: "Waiting to send",
    offState_synced: "In Delta",
    offState_held: "Held for review",
    offState_failed: "Refused by Delta",
    offWhy_not_activated: "This PC is not an activated register.",
    offWhy_not_provisioned: "This register was not prepared for offline sales. Prepare it on POS Home while Delta answers.",
    offWhy_sales_closed: "Delta stopped this business's sales while it removes data. This register sent its saved sales and stopped selling offline; it can be prepared again once Delta releases the business.",
    offWhy_grant_expired: "Offline selling ended for this shift. Sales already saved are kept and sent when Delta answers.",
    offWhy_grant_full: "This register reached the number of offline sales allowed. Saved sales are kept and sent when Delta answers.",
    offWhy_clock_moved: "This PC's clock changed since it was prepared. Offline selling is stopped; set the clock right or wait for Delta.",
    offWhy_empty: "Add an item.",
    offWhy_unknown_item: "Line {n}: this item was not prepared for offline sales.",
    offWhy_blocked_item: "Line {n}: this item cannot be sold offline ({x}).",
    offWhy_bad_qty: "Line {n}: enter a quantity.",
    offWhy_stock: "Line {n}: not enough stock as prepared, after this register's offline sales.",
    offWhy_tender_short: "The cash received is less than the total.",
    offWhy_bad_tender: "Enter the cash received as an amount.",
    offWhy_store_failed: "The sale could not be saved on this PC; nothing was charged. {x}",
    offWhy_other_delta: "This register belongs to another Delta.",
    offWhy_confirm_total: "Confirm the revised total.",
    offBlocked_below_cost: "below cost",
    offBlocked_cost_unknown: "cost not known",
    offBlocked_out_of_stock: "out of stock",
    offBlocked_no_price: "no price",
    offBlocked_tobacco_minimum_not_covered: "the price does not cover the minimum tobacco fee",
    offNotInApp: "The offline register works only in Delta POS for Windows.",
    // Administrator: registers
    regsTitle: "Registers",
    regsIntro: "Registers are the PCs that run Delta POS for Windows. A register you allow to sell offline keeps selling for cash when Delta cannot be reached; its sales come back into Delta as completed POS invoices of the cashier's shift.",
    regsAdminOnly: "Only an administrator manages registers.",
    regsNew: "New register",
    regsCode: "Code",
    regsName: "Name",
    regsTreasury: "Cash drawer",
    regsStatus: "Status",
    regsOffline: "Offline sales",
    regsAllow: "Allow",
    regsStop: "Stop",
    regsActivationCode: "Activation code for {c}: {code} (until {t}). Type it on the register's POS Home.",
    regsNewCode: "New activation code",
    regsReview: "Offline sales held for review",
    regsReviewNone: "No offline sales are held.",
    regsCompleteHeld: "Complete into an invoice",
    regsReason: "Why held",
    regsHeldDone: "Completed into invoice.",
    regsDeactivate: "Deactivate",
    regsDecide: "Record decision",
    regsDecideTitle: "Held sale {r}",
    regsDecideHint: "Delta never turns this sale into an invoice by itself. If the sale stands, enter it at the register from the paper receipt, then link it here to that invoice: the register is told the invoice and no second one is made. Otherwise record why.",
    regsDecideInvoice: "Entered as invoice (for example SI-12)",
    regsDecideNote: "Note",
    regsDecideDisputed: "Dispute it (no invoice)",
    regsDecided: "Decision recorded.",
    regsRecovered: "Sales from registers removed with the business's data",
    regsRecoveredIntro: "A register written off during a data removal sent these after it was found. They are kept exactly as sent and refer to records that were removed, so they are never applied by themselves.",
    regsRecoveredNone: "No sales from removed registers.",
    regsReasonRemoved: "register removed"
  },
  ar: {
    offCardTitle: "البيع دون اتصال على نقطة البيع هذه",
    offCardIntro: "إذا تعذر الوصول إلى دلتا، تستمر نقطة البيع هذه في البيع نقدًا مما جُهّزت به. تُحفظ كل عملية بيع على هذا الجهاز أولًا ثم تُرسل إلى دلتا عند عودة الاتصال.",
    offCardOld: "إصدار تطبيق نقطة البيع هذا لا يدعم البيع دون اتصال. ثبّت أحدث إصدار من صفحة الطابعات على هذا الجهاز.",
    offCardUnavailable: "تعذر تشغيل البيع دون اتصال على هذا الجهاز: {x}",
    offActivateHint: "اجعل هذا الجهاز نقطة بيع في دلتا أولًا: ينشئها المسؤول في صفحة نقاط البيع ويعطيك رمز التفعيل لمرة واحدة.",
    offActivateCode: "رمز التفعيل",
    offActivate: "تفعيل هذا الجهاز",
    offActivated: "هذا الجهاز هو نقطة البيع {code} · {name}.",
    offPrepare: "التجهيز للبيع دون اتصال",
    offPrepareAgain: "إعادة التجهيز",
    offPrepareNeedsShift: "افتح وردية أولًا: تدخل مبيعات دون اتصال إلى صندوق النقد في ورديتك المفتوحة.",
    offPrepared: "مجهزة للوردية {n} حتى {t} · حتى {m} عملية بيع · {i} صنف.",
    offNotPrepared: "غير مجهزة للبيع دون اتصال.",
    offPrepareDone: "نقطة البيع هذه مجهزة للبيع دون اتصال.",
    offAssetsMissing: "لم تُنزّل كل ملفات نقطة البيع ({x})؛ لا يمكن فتحها دون اتصال حتى ينجح التجهيز.",
    offOpen: "فتح نقطة البيع دون اتصال",
    offSyncNow: "إرسال الآن",
    offPending: "بانتظار الإرسال",
    offHeld: "موقوفة للمراجعة",
    offFailed: "مرفوضة",
    offSynced: "أُرسلت",
    offLastError: "آخر محاولة",
    offErr_unreachable: "لم تُجب دلتا",
    offOldest: "أقدمها بانتظار الإرسال منذ {t}",
    offRules: "دون اتصال: نقدًا إلى صندوق هذه الوردية فقط، عميل نقدي، أسعار القائمة، دون خصومات أو مرتجعات أو مسودات. لا تُباع الأصناف دون التكلفة أو بلا تكلفة أو سعر أو غير المتوفرة.",
    offTitle: "نقطة البيع دون اتصال",
    offBanner: "تعذر الوصول إلى دلتا. تُحفظ المبيعات على هذا الجهاز وتُرسل إلى دلتا عند عودة الاتصال.",
    offOnline: "عاد الاتصال بدلتا",
    offOffline: "دون اتصال",
    offBack: "العودة إلى دلتا",
    offCheck: "فحص الاتصال",
    offSales: "مبيعات دون اتصال",
    offSell: "بيع",
    offShift: "الوردية {n} · {c}",
    offDevice: "نقطة البيع {code}",
    offGrantUntil: "البيع دون اتصال حتى {t} · {u} من {m} عملية",
    offComplete: "إتمام البيع نقدًا",
    offSaved: "حُفظت عملية البيع {r} على هذا الجهاز.",
    offReceipt: "الإيصال",
    offPrintCopy: "طباعة نسخة",
    offRetryPrint: "إعادة الطباعة (نفس الإيصال)",
    offNewSale: "بيع جديد",
    offPrinting: "جارٍ الطباعة…",
    offPrinted: "طُبع على {p}.",
    offPrintFailed: "لم يُطبع: {x}. لم يُحتسب شيء مرتين؛ عملية البيع محفوظة.",
    offPrintUnknown: "غير معروف إن طُبع ({x}). انظر إلى الطابعة: إن لم يخرج شيء فاطبع نسخة.",
    offPrintNone: "لا توجد طابعة إيصالات معدّة على هذا الجهاز (الطابعات على هذا الجهاز).",
    offReceiptBanner: "بيع دون اتصال · محفوظ على نقطة البيع ولم يصل إلى دلتا بعد",
    offReceiptNo: "إيصال نقطة البيع",
    offConfirmTotal: "الحد الأدنى لرسوم التبغ يرفع الإجمالي إلى {x}. هل تعتمد هذا الإجمالي؟",
    offConfirm: "اعتماد {x}",
    offNoSales: "لا توجد مبيعات دون اتصال على نقطة البيع هذه.",
    offInvoice: "فاتورة دلتا",
    offState_pending: "بانتظار الإرسال",
    offState_synced: "في دلتا",
    offState_held: "موقوفة للمراجعة",
    offState_failed: "رفضتها دلتا",
    offWhy_not_activated: "هذا الجهاز ليس نقطة بيع مفعّلة.",
    offWhy_not_provisioned: "لم تُجهّز نقطة البيع هذه للبيع دون اتصال. جهّزها من الصفحة الرئيسية لنقطة البيع أثناء الاتصال بدلتا.",
    offWhy_sales_closed: "أوقفت دلتا مبيعات هذه المنشأة أثناء حذف بيانات منها. أرسلت نقطة البيع مبيعاتها المحفوظة وتوقفت عن البيع دون اتصال، ويمكن تجهيزها من جديد بعد أن تُعيد دلتا تفعيل المبيعات.",
    offWhy_grant_expired: "انتهى البيع دون اتصال لهذه الوردية. المبيعات المحفوظة باقية وتُرسل عند عودة الاتصال.",
    offWhy_grant_full: "بلغت نقطة البيع عدد المبيعات المسموح دون اتصال. المبيعات المحفوظة باقية وتُرسل عند عودة الاتصال.",
    offWhy_clock_moved: "تغيّرت ساعة هذا الجهاز منذ التجهيز. توقف البيع دون اتصال؛ صحّح الساعة أو انتظر الاتصال بدلتا.",
    offWhy_empty: "أضف صنفًا.",
    offWhy_unknown_item: "السطر {n}: هذا الصنف غير مجهز للبيع دون اتصال.",
    offWhy_blocked_item: "السطر {n}: لا يُباع هذا الصنف دون اتصال ({x}).",
    offWhy_bad_qty: "السطر {n}: أدخل الكمية.",
    offWhy_stock: "السطر {n}: المخزون غير كافٍ كما جُهّز، بعد مبيعات نقطة البيع دون اتصال.",
    offWhy_tender_short: "النقد المستلم أقل من الإجمالي.",
    offWhy_bad_tender: "أدخل النقد المستلم كمبلغ.",
    offWhy_store_failed: "تعذر حفظ عملية البيع على هذا الجهاز؛ لم يُحتسب شيء. {x}",
    offWhy_other_delta: "نقطة البيع هذه تابعة لدلتا أخرى.",
    offWhy_confirm_total: "اعتمد الإجمالي المعدّل.",
    offBlocked_below_cost: "دون التكلفة",
    offBlocked_cost_unknown: "التكلفة غير معروفة",
    offBlocked_out_of_stock: "غير متوفر",
    offBlocked_no_price: "بلا سعر",
    offBlocked_tobacco_minimum_not_covered: "السعر لا يغطي الحد الأدنى لرسوم التبغ",
    offNotInApp: "تعمل نقطة البيع دون اتصال في تطبيق دلتا لنقاط البيع على ويندوز فقط.",
    regsTitle: "نقاط البيع",
    regsIntro: "نقاط البيع هي الأجهزة التي تشغّل تطبيق دلتا لنقاط البيع على ويندوز. نقطة البيع المسموح لها بالبيع دون اتصال تستمر في البيع نقدًا عند تعذر الوصول إلى دلتا، وتعود مبيعاتها إلى دلتا كفواتير نقطة بيع مكتملة في وردية الكاشير.",
    regsAdminOnly: "إدارة نقاط البيع للمسؤول فقط.",
    regsNew: "نقطة بيع جديدة",
    regsCode: "الرمز",
    regsName: "الاسم",
    regsTreasury: "صندوق النقد",
    regsStatus: "الحالة",
    regsOffline: "البيع دون اتصال",
    regsAllow: "سماح",
    regsStop: "إيقاف",
    regsActivationCode: "رمز تفعيل {c}: {code} (حتى {t}). اكتبه في الصفحة الرئيسية لنقطة البيع.",
    regsNewCode: "رمز تفعيل جديد",
    regsReview: "مبيعات دون اتصال موقوفة للمراجعة",
    regsReviewNone: "لا توجد مبيعات دون اتصال موقوفة.",
    regsCompleteHeld: "إتمامها في فاتورة",
    regsReason: "سبب الإيقاف",
    regsHeldDone: "أُتمّت في فاتورة.",
    regsDeactivate: "إيقاف التفعيل",
    regsDecide: "تسجيل القرار",
    regsDecideTitle: "بيع موقوف {r}",
    regsDecideHint: "لا تحوّل دلتا هذا البيع إلى فاتورة من تلقاء نفسها. إن كان البيع صحيحًا فأدخله في نقطة البيع من الإيصال الورقي، ثم اربطه هنا بتلك الفاتورة: تُبلَّغ نقطة البيع بالفاتورة ولا تُنشأ فاتورة ثانية. وإلا فسجّل السبب.",
    regsDecideInvoice: "أُدخل في الفاتورة (مثل SI-12)",
    regsDecideNote: "ملاحظة",
    regsDecideDisputed: "الاعتراض عليه (دون فاتورة)",
    regsDecided: "سُجّل القرار.",
    regsRecovered: "مبيعات من نقاط بيع حُذفت مع بيانات المنشأة",
    regsRecoveredIntro: "أرسلتها نقطة بيع شُطبت أثناء حذف البيانات بعد العثور عليها. تُحفظ كما أُرسلت تمامًا وتشير إلى سجلات حُذفت، لذا لا تُطبَّق من تلقاء نفسها أبدًا.",
    regsRecoveredNone: "لا توجد مبيعات من نقاط بيع محذوفة.",
    regsReasonRemoved: "نقطة البيع محذوفة"
  }
};
